module.exports = __webpack_public_path__ + "img/avatar.5f68568c.png";